<template>
  <div class="d-flex justify-space-between align-center nav-area mb-4">
    <v-btn
      class="pa-0 nav-button"
      text
      color="muted"
      x-small
      width="20px"
      @click="handleSingleNavigation('back')"
    >
      <v-icon
        color="muted"
        size="14px"
      >
        $faChevronLeft
      </v-icon>
    </v-btn>
    <span style="color: #456E6C">{{ userNumber }} / {{ formattedTotal }}</span>
    <v-btn
      class="pa-0 nav-button"
      text
      x-small
      width="20px"
      @click="handleSingleNavigation('forward')"
    >
      <v-icon
        color="muted"
        size="14px"
      >
        $faChevronRight
      </v-icon>
    </v-btn>
  </div>
</template>

<script>
  import { mapGetters } from 'vuex'

  export default {
    name: 'UserPagination',
    computed: {
      ...mapGetters({
        totalUsers: 'Users/totalUsers',
        currentOrgUser: 'Users/currentOrgUser',
        currentSelectedOrg: 'Permissions/currentSelectedOrg',
      }),
      userIndex () {
        return Number.parseInt(this.$route.query.index) || 1
      },
      userNumber () {
        return `${this.userIndex}`.padStart(2, '0')
      },
      formattedTotal () {
        return `${this.totalUsers}`.padStart(2, '0')
      },
    },
    methods: {
      async handleSingleNavigation (direction) {
        let nextPageNum =
          direction === 'forward'
            ? this.userIndex + 1
            : this.userIndex - 1
        // check if at end (for forwards) or if at beginning (for backwards)
        if (nextPageNum > this.totalUsers) nextPageNum = 1
        else if (nextPageNum < 1) nextPageNum = this.totalUsers
        const payload = {
          filter: [
            {
              key: 'organization_id',
              operator: '=',
              value: `${this.currentSelectedOrg.id}`,
            },
          ],
          pagination: { pageNum: nextPageNum, perPage: 1 },
        }
        await this.$store.dispatch('Users/fetchNextUser', payload)
          .then(() => this.$store.dispatch('Users/fetchUserData', this.currentOrgUser.id))
          .then(() => this.$store.dispatch('Users/fetchUserNotificationSettings', this.currentOrgUser.id))
          .then(() => {
            this.$router.push({
              path: `/organizations/${this.currentSelectedOrg.id}/users/${this.currentOrgUser.id}`,
              query: { index: nextPageNum },
            })
          })
      },
    },
  }
</script>
